import { ref, watch } from 'vue-demi';
import { use } from '@fegobull/webapi';
const { useVariable } = use;
let data = null;
if (useVariable) {
    data = useVariable();
}

// 邀请码
export const code = ref('{code}');
// 邀请链接
export const inviteLink = ref('{inviteLink}');

if (!window.FEGOEditor) {
    watch(
        () => [data?.inviteGuideCode, data?.inviteGuideInviteLink],
        () => {
            code.value = (window?._params?.payload?.code || data?.inviteGuideCode) ?? '';
            inviteLink.value = (window?._params?.payload?.inviteLink || data?.inviteGuideInviteLink) ?? '';
        },
        {
            immediate: true
        }
    );
}
